import { LuArrowLeft } from 'react-icons/lu';

interface FormHeaderProps {
    currentStep: number;
    totalSteps: number;
    isFirstStep: boolean;
    onBack: () => void;
    onCancel?: () => void;
}

export const FormHeader = ({ currentStep, totalSteps, isFirstStep, onBack, onCancel }: FormHeaderProps) => {
    const handleClick = () => {
        if (isFirstStep && onCancel) {
            onCancel();
        } else {
            onBack();
        }
    };

    const buttonLabel = isFirstStep ? 'Cancel' : 'Back';

    return (
        <div className='mb-8 flex w-full items-center justify-between'>
            <button
                onClick={handleClick}
                className='text-semantic-fg-muted hover:text-dark flex cursor-pointer items-center gap-2 text-xs font-medium transition-colors duration-300 md:text-sm'
            >
                <div className='bg-bg-muted rounded-full p-1'>
                    <LuArrowLeft className='text-neutral-fg-secondary' />
                </div>
                <span>{buttonLabel}</span>
            </button>
            <span className='text-neutral-fg-secondary text-sm font-semibold'>
                {currentStep}/{totalSteps}
            </span>
        </div>
    );
};
